module.exports = new __parcel__URL__("Red.94592ce4.png").toString();